import React from "react";
import * as TermosGlampartner from "components/markdown/TermosGlampartner.md";
import { Helmet } from "react-helmet";

export class TermosGp extends React.Component {

  render() {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners: Termos de Aceite</title>
        </Helmet>

        <h1>Termos de aceite</h1>
        <div className={"gb-contentblock level-2 gb-markdown"}>
          <div className={"legal-texts"}>
            <TermosGlampartner.react />
          </div>
        </div>
      </div>
    )
  }
}


